import React, { useState } from 'react';
import { LINK_TYPE } from '../../../../utils/constants';

const LinkEditSlideInLinkType = ({ type, defaultLink }) => {
  // useState-Hooks für Social Media
  const [selectedNetzwerk, setSelectedNetzwerk] = useState(() => {
    const currentNetzwerk = defaultLink?.netzwerk || '';
    const standardNetworks = ['facebook', 'linkedin', 'twitter'];
    return standardNetworks.includes(currentNetzwerk)
      ? currentNetzwerk
      : 'eigenes';
  });

  const [customNetzwerkName, setCustomNetzwerkName] = useState(() => {
    const currentNetzwerk = defaultLink?.netzwerk || '';
    const standardNetworks = ['facebook', 'linkedin', 'twitter', 'eigenes'];
    return !standardNetworks.includes(currentNetzwerk) ? currentNetzwerk : '';
  });
  // Geburtstag für HTML umformen
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  return (
    <div className="pb-5">
      {type === LINK_TYPE.ADRESSE_FIRMA || type === LINK_TYPE.ADRESSE_PRIVAT ? (
        <>
          <label
            htmlFor="strasse"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Strasse
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="strasse"
              name="strasse"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.strasse || ''}
            />
          </div>
          <label
            htmlFor="plz"
            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
          >
            Postleitzahl
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="plz"
              name="plz"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.plz || ''}
            />
          </div>

          <label
            htmlFor="ort"
            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
          >
            Ort
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="ort"
              name="ort"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.ort || ''}
            />
          </div>
        </>
      ) : type === LINK_TYPE.TELEFON_ARBEIT ||
        type === LINK_TYPE.TELEFON_PRIVAT ? (
        <>
          <label
            htmlFor="telefonnummer"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Telefonnummer
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="telefonnummer"
              name="telefonnummer"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.telefonnummer || ''}
            />
          </div>
        </>
      ) : type === LINK_TYPE.EMAIL_ARBEIT || type === LINK_TYPE.EMAIL_PRIVAT ? (
        <>
          <label
            htmlFor="email"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            E-Mail Adresse
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="email"
              name="email"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.email || ''}
            />
          </div>
        </>
      ) : type === LINK_TYPE.GEBURTSTAG ? (
        <>
          <label
            htmlFor="geburtstag"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Geburtstag
          </label>
          <div className="mt-2">
            <input
              type="date"
              id="geburtstag"
              name="geburtstag"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={formatDate(defaultLink?.geburtstag) || ''}
            />
          </div>
        </>
      ) : type === LINK_TYPE.NOTIZEN ? (
        <>
          <label
            htmlFor="link"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Notizen
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="link"
              name="link"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.link || ''}
            />
          </div>
        </>
      ) : type === LINK_TYPE.SOCIAL_MEDIA ? (
        <>
          <label
            htmlFor="netzwerk"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Netzwerk auswählen
          </label>
          <div className="mt-2">
            <select
              id="netzwerk"
              name="netzwerk"
              className="mt-2 block w-full rounded-md border-0 px-3 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              value={selectedNetzwerk}
              onChange={(e) => setSelectedNetzwerk(e.target.value)}
            >
              <option value="facebook">Facebook</option>
              <option value="linkedin">LinkedIn</option>
              <option value="twitter">Twitter</option>
              <option value="eigenes">Eigenes</option>
            </select>
          </div>

          {/* Verstecktes Feld für den tatsächlichen Wert */}
          <input
            type="hidden"
            name="netzwerk"
            value={
              selectedNetzwerk === 'eigenes'
                ? customNetzwerkName
                : selectedNetzwerk
            }
          />

          {/* Eingabefeld für eigenes Netzwerk */}
          {selectedNetzwerk === 'eigenes' && (
            <div>
              <label
                htmlFor="customNetzwerkInput"
                className="block text-sm font-medium leading-6 text-gray-900 mt-4"
              >
                Name des Netzwerks
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="customNetzwerkInput"
                  className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                  placeholder="z.B. Instagram, TikTok, Xing..."
                  value={customNetzwerkName}
                  onChange={(e) => setCustomNetzwerkName(e.target.value)}
                />
              </div>
            </div>
          )}

          <label
            htmlFor="link"
            className="block text-sm font-medium leading-6 text-gray-900 mt-4"
          >
            Profil-Link
          </label>
          <div className="mt-2 flex">
            <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 px-3 text-gray-500 sm:text-sm">
              https://
            </span>
            <input
              type="text"
              id="link"
              name="link"
              className="block w-full rounded-none rounded-r-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.link || ''}
            />
          </div>
        </>
      ) : (
        <>
          <label
            htmlFor="link"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Link
          </label>
          <div className="mt-2">
            <input
              type="text"
              id="link"
              name="link"
              className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
              defaultValue={defaultLink?.link || ''}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LinkEditSlideInLinkType;
